import { createPageTableSchema } from '@state/_shared/tableComponentStateSchema';

// Define the specific structure for a row in the sources table
const sourcesRowSchema = {
    type: 'object',
    properties: {
        // Core identifier
        id: { type: ['string', 'number'], default: '' },
        
        // Source details
        name: { type: 'string', default: '' },
        notes: { type: ['string', 'null'], default: null },
        
        // Timestamps
        createdAt: { type: ['string', 'null'], default: null },
        updatedAt: { type: ['string', 'null'], default: null }
    }
};

// Define the possible action states for rows in this specific table
const sourcesRowActions = {
    isUpdating: { type: 'boolean', default: false },
    isDeleting: { type: 'boolean', default: false },
    isExporting: { type: 'boolean', default: false }
};

// Create the table schema specific to this page
const pageTableSchema = createPageTableSchema(sourcesRowSchema, sourcesRowActions);

// Schema definition for sources page state
export const sourcesPageStateSchema = {
    // Table State (using the shared schema)
    table: pageTableSchema,
    
    // Dialog States (for create/edit dialogs)
    createDialog: {
        type: 'object',
        properties: {
            isOpen: { type: 'boolean', default: false },
            isSubmitting: { type: 'boolean', default: false }
        }
    },
    editDialog: {
        type: 'object',
        properties: {
            isOpen: { type: 'boolean', default: false },
            isSubmitting: { type: 'boolean', default: false },
            selectedSource: {
                type: ['object', 'null'],
                default: null,
                properties: {
                    id: { type: ['string', 'number'] },
                    name: { type: 'string' },
                    notes: { type: ['string', 'null'] }
                }
            }
        }
    }
};

export default sourcesPageStateSchema;